import type { FleetSlashCommand } from "./fleet-slash-commands.ts";

/** Browser-safe slash commands (sync with commands-registry.data via fleet-slash-commands.sync.node.test.ts). */
export const FLEET_SLASH_COMMANDS_DATA: FleetSlashCommand[] = [
  {
    name: "activation",
    description: "Set group activation mode.",
    acceptsArgs: true,
  },
  {
    name: "allowlist",
    description: "List/add/remove allowlist entries.",
    acceptsArgs: true,
  },
  {
    name: "approve",
    description: "Approve or deny exec requests.",
    acceptsArgs: true,
  },
  {
    name: "arte",
    description: "Run arte-loco docker compose commands.",
    acceptsArgs: true,
  },
  {
    name: "arte-loco",
    description: "Run arte-loco docker compose commands.",
    acceptsArgs: true,
  },
  {
    name: "bash",
    description: "Run host shell commands (host-only).",
    acceptsArgs: true,
  },
  {
    name: "best-of-n",
    description: "Run N parallel agent attempts (Fleet Control)",
    acceptsArgs: true,
  },
  {
    name: "commands",
    description: "List all slash commands.",
    acceptsArgs: false,
  },
  {
    name: "compact",
    description: "Compact the session context.",
    acceptsArgs: true,
  },
  {
    name: "config",
    description: "Show or set config values.",
    acceptsArgs: true,
  },
  {
    name: "context",
    description: "Explain how context is built and used.",
    acceptsArgs: true,
  },
  {
    name: "debug",
    description: "Set runtime debug overrides.",
    acceptsArgs: true,
  },
  {
    name: "dock_discord",
    description: "Switch to discord for replies.",
    acceptsArgs: false,
  },
  {
    name: "dock_slack",
    description: "Switch to slack for replies.",
    acceptsArgs: false,
  },
  {
    name: "dock_telegram",
    description: "Switch to telegram for replies.",
    acceptsArgs: false,
  },
  {
    name: "dock-discord",
    description: "Switch to discord for replies.",
    acceptsArgs: false,
  },
  {
    name: "dock-slack",
    description: "Switch to slack for replies.",
    acceptsArgs: false,
  },
  {
    name: "dock-telegram",
    description: "Switch to telegram for replies.",
    acceptsArgs: false,
  },
  {
    name: "elev",
    description: "Toggle elevated mode.",
    acceptsArgs: true,
  },
  {
    name: "elevated",
    description: "Toggle elevated mode.",
    acceptsArgs: true,
  },
  {
    name: "exec",
    description: "Set exec defaults for this session.",
    acceptsArgs: true,
  },
  {
    name: "harness_audit",
    description: "Audit harness posture (security + command/session settings).",
    acceptsArgs: false,
  },
  {
    name: "harness-audit",
    description: "Audit harness posture (security + command/session settings).",
    acceptsArgs: false,
  },
  {
    name: "help",
    description: "Show available commands.",
    acceptsArgs: false,
  },
  {
    name: "id",
    description: "Show your sender id.",
    acceptsArgs: false,
  },
  {
    name: "model",
    description: "Show or set the model.",
    acceptsArgs: true,
  },
  {
    name: "models",
    description: "List model providers or provider models.",
    acceptsArgs: true,
  },
  {
    name: "new",
    description: "Start a new session.",
    acceptsArgs: true,
  },
  {
    name: "queue",
    description: "Adjust queue settings.",
    acceptsArgs: true,
  },
  {
    name: "reason",
    description: "Toggle reasoning visibility.",
    acceptsArgs: true,
  },
  {
    name: "reasoning",
    description: "Toggle reasoning visibility.",
    acceptsArgs: true,
  },
  {
    name: "reset",
    description: "Reset the current session.",
    acceptsArgs: true,
  },
  {
    name: "restart",
    description: "Restart Jaisiu.",
    acceptsArgs: false,
  },
  {
    name: "revert",
    description: "Revert the last queued followup message.",
    acceptsArgs: false,
  },
  {
    name: "send",
    description: "Set send policy.",
    acceptsArgs: true,
  },
  {
    name: "skill",
    description: "Run a skill by name.",
    acceptsArgs: true,
  },
  {
    name: "status",
    description: "Show current status.",
    acceptsArgs: false,
  },
  {
    name: "stop",
    description: "Stop the current run.",
    acceptsArgs: false,
  },
  {
    name: "subagents",
    description: "List/stop/log/info subagent runs for this session.",
    acceptsArgs: true,
  },
  {
    name: "t",
    description: "Set thinking level.",
    acceptsArgs: true,
  },
  {
    name: "think",
    description: "Set thinking level.",
    acceptsArgs: true,
  },
  {
    name: "thinking",
    description: "Set thinking level.",
    acceptsArgs: true,
  },
  {
    name: "tts",
    description: "Control text-to-speech (TTS).",
    acceptsArgs: true,
  },
  {
    name: "usage",
    description: "Usage footer or cost summary.",
    acceptsArgs: true,
  },
  {
    name: "v",
    description: "Toggle verbose mode.",
    acceptsArgs: true,
  },
  {
    name: "verbose",
    description: "Toggle verbose mode.",
    acceptsArgs: true,
  },
  {
    name: "whoami",
    description: "Show your sender id.",
    acceptsArgs: false,
  },
];
